/**
 * @ngdoc function
 * @name app.controller:Dev4Ctrl
 * @description
 * # Dev4Ctrl
 * Controller of the app
 */
export default class {
	/* @ngInject */
	constructor($scope) {
		this.$scope = $scope;
	}
}
